import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row ,Dropdown} from 'react-bootstrap';
  import { Link, useNavigate } from "react-router-dom";

const API_URL = "https://subk.education.com.ly/back/api/fixed-assets";
const ACCOUNT_API = "https://subk.education.com.ly/back/api/accounts";

function FixedAssetsPage() {

    const navigate = useNavigate(); // Use useNavigate hook for navigation

   ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'FixedAssetsPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [assets, setAssets] = useState([]);
  const [form, setForm] = useState({
    AssetName: "",
    AccountID: "",
    PurchaseDate: "",
    PurchasePrice: "",
    UsefulLifeMonths: "",
    DepreciationMethod: "StraightLine",
    Notes: "",
      PaymentAccountID: "",
      UserID:'',
      CompanyID:'',
  });
    const [company, setCompany] = useState({});
  
     const userdata = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata);
    const userid = userData.id;
  
    // Fetch company data from localStorage
    useEffect(() => {
      const companyData = localStorage.getItem('companies');
      if (companyData) {
        const parsedData = JSON.parse(companyData);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setCompany(singleCompany); // Set the company data
      }
    }, []);
  // Initialize hallData with company data and user id when company is set
    useEffect(() => {
      if (company.CompanyID && userid) {
        setForm((prevData) => ({
          ...prevData,
          CompanyID: company.CompanyID,
          UserID: userid,
        }));
      }
    }, [company, userid]);
  const [editingId, setEditingId] = useState(null);
const [accounts, setAccounts] = useState([]);
    useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await axios.get(ACCOUNT_API);
        setAccounts(res.data);
      } catch (err) {
        console.error("Error fetching accounts", err);
      }
    };
    fetchAccounts();
  }, []);
  // const fetchAssets = async () => {
  //   try {
  //     const res = await axios.get(API_URL);
  //     setAssets(res.data);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  const [filters, setFilters] = useState({
  AssetName: "",
  AccountID: "",
  PurchaseDate: ""
});

const fetchAssets = async () => {
  try {
    const params = {};
    if (filters.AssetName) params.AssetName = filters.AssetName;
    if (filters.AccountID) params.AccountID = filters.AccountID;
    if (filters.PurchaseDate) params.PurchaseDate = filters.PurchaseDate;

    const res = await axios.get(API_URL, { params });
    setAssets(res.data);
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  fetchAssets();
}, [filters]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, form);
      } else {
        await axios.post(API_URL, form);
      }
      setForm({
        AssetName: "",
        AccountID: "",
        PurchaseDate: "",
        PurchasePrice: "",
        UsefulLifeMonths: "",
        DepreciationMethod: "StraightLine",
        Notes: ""
      });
              setShowRegisterForm(false);

      setEditingId(null);
      fetchAssets();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء الحفظ");
    }
  };

  const handleEdit = (asset) => {
            setShowRegisterForm(true);

    setForm({
      AssetName: asset.AssetName,
      AccountID: asset.AccountID,
      PurchaseDate: asset.PurchaseDate,
      PurchasePrice: asset.PurchasePrice,
      UsefulLifeMonths: asset.UsefulLifeMonths,
      DepreciationMethod: asset.DepreciationMethod,
      Notes: asset.Notes || ""
    });
    setEditingId(asset.AssetID);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد أنك تريد حذف هذا الأصل؟")) return;
    try {
      await axios.delete(`${API_URL}/${id}`);
      fetchAssets();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء الحذف");
    }
  };
const [showRegisterForm, setShowRegisterForm] = useState(false);

   
  return (
     
   <div className='container-fluid'>
              <Row>
                <Col lg="12">
                  <div className="card p-3">
                  <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
      
                       <div className="tbl-caption">
                       <h4 className="heading ms-3">إدارة الأصول الثابتة</h4>
                                    {!showRegisterForm && (
  
                        < Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                                      onClick={() => setShowRegisterForm(true)}
  > + إضافة أصل </Link>  
                                      
                                  )}
                              </div>  
                              </div>   </div> 
                                                            {showRegisterForm && (
      <form className="row g-3 mb-4" onSubmit={handleSubmit}>
        <div className="col-md-2">
          <input
            type="text"
            name="AssetName"
            className="form-control"
            placeholder="اسم الأصل"
            value={form.AssetName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-2">
          <select
                className="default-select form-control "
                name="AccountID"
                value={form.AccountID}
            onChange={handleChange}
                required
              >
                <option value="">--اختر الحساب--</option>
                {accounts.map(acc => (
                  <option key={acc.AccountID} value={acc.AccountID}>{acc.AccountName}</option>
                ))}
              </select>
          {/* <input
            type="number"
            name="AccountID"
            className="form-control"
            placeholder="معرف الحساب"
            value={form.AccountID}
            onChange={handleChange}
            required
          /> */}
          
        </div>
        <div className="col-md-2">
          <input
            type="date"
            name="PurchaseDate"
            className="form-control"
            value={form.PurchaseDate}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-2">
          <input
            type="number"
            step="0.01"
            name="PurchasePrice"
            className="form-control"
            placeholder="سعر الشراء"
            value={form.PurchasePrice}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-2">
          <input
            type="number"
            name="UsefulLifeMonths"
            className="form-control"
            placeholder="العمر (أشهر)"
            value={form.UsefulLifeMonths}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-3">
          <select
            name="DepreciationMethod"
            className="default-select form-control "
            value={form.DepreciationMethod}
            onChange={handleChange}
          >
            <option value="StraightLine">القسط الثابت</option>
           </select>
        </div>
        <div className="col-md-2">
  <select
    name="PaymentAccountID"
    className="default-select form-control"
    value={form.PaymentAccountID || ""}
    onChange={(e) => setForm({ ...form, PaymentAccountID: e.target.value })}
    required
  >
    <option value="">-- اختر حساب الدفع --</option>
    {accounts.map((acc) => (
      <option key={acc.AccountID} value={acc.AccountID}>
        {acc.AccountName}
      </option>
    ))}
  </select>
</div>

        <div className="col-md-5">
          <input
            type="text"
            name="Notes"
            className="form-control"
            placeholder="ملاحظات"
            value={form.Notes}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-2">
          <button type="submit" className="btn btn-primary mx-2">
            {editingId ? "تحديث" : "إضافة"}
          </button>
            <button   className="btn btn-danger  "
                            onClick={() => setShowRegisterForm(false)}
>
           الغاء
          </button>
        </div>
      </form>
                                                            )}

<Row className="g-2 m-3" style={{borderTop:' var(--bs-card-border-width) solid var(--bs-card-border-color)'}}>
  <Col>
    <input
      type="text"
      name="AssetName"
      placeholder="البحث بالاسم"
      className="form-control"
      value={filters.AssetName}
      onChange={(e) => setFilters({ ...filters, AssetName: e.target.value })}
    />
  </Col>
  <Col>
    <input
      type="number"
      name="AccountID"
      placeholder="البحث بالحساب"
      className="form-control"
      value={filters.AccountID}
      onChange={(e) => setFilters({ ...filters, AccountID: e.target.value })}
    />
  </Col>
  <Col>
    <input
      type="date"
      name="PurchaseDate"
      className="form-control"
      value={filters.PurchaseDate}
      onChange={(e) => setFilters({ ...filters, PurchaseDate: e.target.value })}
    />
  </Col>
</Row>
<br/>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>المعرف</th>
            <th>الاسم</th>
            <th>الحساب</th>
            <th>تاريخ الشراء</th>
            <th>السعر</th>
            <th>العمر</th>
            <th>طريقة الاهلاك</th>
            <th>الملاحظات</th>
            {/* <th>الإجراءات</th> */}
          </tr>
        </thead>
        <tbody>
          {assets.length>0 ?(
          
          assets.map((asset) => (
            <tr key={asset.AssetID}>
              <td>{asset.AssetID}</td>
              <td>{asset.AssetName}</td>
              <td>{asset.AccountID}</td>
              <td>{asset.PurchaseDate}</td>
              <td>{asset.PurchasePrice}</td>
              <td>{asset.UsefulLifeMonths}</td>
              <td>
                {asset.DepreciationMethod === "StraightLine"
                  ? "القسط الثابت"
                  : "الميزان المتناقص"}
              </td>
              <td>{asset.Notes || "-"}</td>
              {/* <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(asset)}
                >
                  تعديل
                </button>
                 
              </td> */}
            </tr>
          ))
        ):(
<tr>
        <td colSpan="9">لاتوجد بيانات لعرضها.</td>
      </tr>

        )
        }
        </tbody>
      </table>
</div>
					</Col>
				</Row>
			</div>   );
}

export default FixedAssetsPage;
